<template>
	<!-- 巡视信息列表 -->
	<div class="mod-config">
		<el-card body-style="padding-bottom: 0;" style="margin-top: -5px;">
			<div class="title">{{ title }}</div>
			<div class="line"></div>
			<el-row style="margin-top: -10px;margin-left: -20px;width: 100%; line-height:30px;">
				<el-row v-if="showSubject">
					<el-col :span="2">
						<div class="search_title">标的物</div>
					</el-col>
					<el-col :span="22" style="display: flex;flex-wrap: wrap;">
						<span v-for="(subject, index) in subjectList" style="margin-right: 20px;">
							<span class="search_sec_bn_border"
								v-if="subjectNo === subject.displayValue && subject.displayName == '全部'"
								@click="setSubject(subject)">
								{{ subject.displayName }}
							</span>
							<span class="search_sec_bn"
								v-else-if="subjectNo !== subject.displayValue && subject.displayName == '全部'"
								@click="setSubject(subject)">
								{{ subject.displayName }}
							</span>
							<span class="search_bn_border"
								v-if="subjectNo === subject.displayValue && subject.displayName != '全部'"
								@click="setSubject(subject)">
								{{ subject.displayName }}
							</span>
							<span class="search_bn"
								v-else-if="subjectNo !== subject.displayValue && subject.displayName != '全部'"
								@click="setSubject(subject)">
								{{ subject.displayName }}
							</span>
						</span>
					</el-col>
				</el-row>
				<el-row style="margin-top: 2px;">
					<el-col :span="2">
						<div class="search_title">专业</div>
					</el-col>
					<el-col :span="10" style="display: flex;flex-wrap: wrap;">
						<span v-for="(maj, index) in majorList" style="margin-right: 20px;">
							<span class="search_sec_bn_border" v-if="major === maj.displayValue" @click="setMajor(maj)">
								{{ maj.displayName }}
							</span>
							<span class="search_sec_bn" v-else-if="major !== maj.displayValue" @click="setMajor(maj)">
								{{ maj.displayName }}
							</span>
						</span>
					</el-col>
					<el-col :span="2">
						<div class="search_title">封闭状态</div>
					</el-col>
					<el-col :span="10" style="display: flex;flex-wrap: wrap;">
						<span v-for="(clo, index) in closeStateList" style="margin-right: 20px;">
							<span class="search_sec_bn_border" v-if="closeState === clo.value" @click="setClo(clo)">
								{{ clo.label }}
							</span>
							<span class="search_sec_bn" v-else-if="closeState !== clo.value" @click="setClo(clo)">
								{{ clo.label }}
							</span>
						</span>
					</el-col>
				</el-row>
				<el-row style="margin-top: 2px;">
					<el-col :span="2">
						<div class="search_title">等级</div>
					</el-col>
					<el-col :span="10" style="display: flex;flex-wrap: wrap;">
						<span v-for="(clo, index) in primaryLabelList" :key="'clo' + index" style="margin-right: 20px;">
							<span class="search_sec_bn_border" v-if="primaryFlg === clo.value" @click="setPrimary(clo)">
								{{ clo.label }}
							</span>
							<span class="search_sec_bn" v-else-if="primaryFlg !== clo.value" @click="setPrimary(clo)">
								{{ clo.label }}
							</span>
						</span>
					</el-col>
				</el-row>
			</el-row>
			<div class="line" style="margin-top: 0px;"></div>
			<el-row>
				<el-row
					style="background-color: rgb(243, 247, 247);margin-top: -10px;height: 45px;width: 103%;margin-left: -20px;">
					<el-col :span="11" style="margin-top:5px">
						<!-- <el-button v-preventReClick class="defaultPlainBtn" plain icon="el-icon-circle-plus-outline"
					@click="addOrUpdateHandle()" v-if="showAdd">添加前</el-button> -->
						<el-button v-preventReClick class="btn" type="primary" size="small" @click="addHandle()"
							style="margin-left: 20px;" v-if="showAdd" :disabled="updateFlg || addFlg">新增</el-button>
						<el-button v-preventReClick class="btn" type="primary" size="small"
							:disabled="updateFlg || addFlg" @click="uploadHandle()">导入</el-button>
						<el-button v-preventReClick class="btn" type="primary" size="small"
							:disabled="updateFlg || addFlg" @click="downloadHandle()">导出</el-button>
						<el-button v-preventReClick class="btn" type="primary" size="small"
							:disabled="updateFlg || addFlg" @click="downloadTemplate()">模板下载</el-button>
						<el-button v-preventReClick class="btn" type="primary" size="small"
							:disabled="disabledBatchDelete || updateFlg || addFlg" @click="deleteBatch()">删除</el-button>
						<!-- <el-button v-preventReClick class="btn" type="primary" size="small"
							:disabled="updateFlg || addFlg" @click="downloadAllDataHandle()">所有数据导出</el-button> -->
					</el-col>
					<el-col :span="12" style="margin-top: 15px;">
						<!-- <div style="float: right;margin-right: 15px;vertical-align:middle;">
						<span style="font-size: 16px; font-weight:bold;vertical-align: middle">已封闭 {{ dataTotal.closeNum }} 未封闭 {{ dataTotal.nonCloseNum }}</span>
					</div> -->
						<div style="float: right;margin-right: 15px;vertical-align:middle;margin-top: -5px;">
							<span style="font-size: 15px; font-weight: bold;vertical-align: middle">已封闭 </span>
							<span
								style="font-size: 15px; font-weight: bold;vertical-align: middle;color:rgb(67, 167, 92);">{{
									dataTotal.closeNum }} </span>
							<span style="font-size: 15px; font-weight: bold;vertical-align: middle">未封闭 </span>
							<span
								style="font-size: 15px; font-weight:bold;vertical-align: middle;color:rgb(207, 67, 91);">{{
									dataTotal.nonCloseNum }}</span>
						</div>
					</el-col>
				</el-row>
			</el-row>
			<div class="line" style="margin-top: -4px;"></div>
			<el-form ref="form" :model="form" inline label-width="70px" label-position="left">
				<el-row
					style="background-color: rgb(243, 247, 247);margin-top: -10px;margin-left: -20px;height: 45px;width: 103%;">
					<el-col :span="20" style="margin-left:20px">
						<!-- <el-form-item label="状态" class="selFormItem">
							<el-select class="selMajorInput" v-model="closeState" placeholder="请选择"
								:disabled="updateFlg || addFlg" clearable>
								<el-option v-for="item in closeStateList" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item> -->
						<el-form-item label="巡视时间" class="selFormItem">
							<el-date-picker class="selDateInput" v-model="poseTime" type="daterange"
								value-format="yyyy-MM-dd" range-separator="~" start-placeholder="开始日期"
								end-placeholder="结束日期" :disabled="updateFlg || addFlg" clearable>
							</el-date-picker>
						</el-form-item>
						<el-form-item label="巡检内容" class="selFormItem">
							<el-input class="selSearchInput" v-model="inspectionContent" :disabled="updateFlg || addFlg"
								clearable></el-input>
						</el-form-item>
						<el-form-item label="问题描述及整改意见" class="selFormItem2">
							<el-input class="selSearchInput" v-model="sutContent" :disabled="updateFlg || addFlg"
								clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="3" class="selBtnGroup" style="margin-top:5px">
						<el-button v-preventReClick class="btn" type="primary" size="small" @click="selGetDataList()"
							:disabled="updateFlg || addFlg" v-if="showSearch">查询</el-button>
						<el-button v-preventReClick class="rebtn" size="small" :disabled="updateFlg || addFlg"
							@click="resetFormData()">重置</el-button>
					</el-col>
				</el-row>
			</el-form>
		</el-card>
		<div>
			<el-card style="margin-top: -30px;" body-style="padding: 0;">
				<el-row style="margin-bottom: 10px;">
					<el-col :span="24">
						<div class="box">
							<el-table :height="getTableHeight()" :row-class-name="tableRowClassName" ref="dataListTable"
								class="dataListTable" :data="dataList" header-align="center" border
								:row-style="selectRowBackground" header-cell-class-name="dataListTHeader"
								@selection-change="handleSelectionChange"
								:cell-style="{ padding: '0px', height: 'auto', minHeight: '15px' }"
								style="margin-bottom: 20px;">
								<el-table-column type="selection" width="60" align="center"></el-table-column>
								<el-table-column label="NO." width="60" align="center" fixed="left">
									<template slot-scope="scope">{{ (pageIndex2 - 1) * pageSize + scope.$index + 1
									}}</template>
								</el-table-column>
								<el-table-column prop="inspectionKind" label="巡检类型" width="100" header-align="center"
									align="left" fixed="left">
									<template slot-scope="scope">
										<span v-if="!getDisabled(scope.row.inspectionId)"
											style=" border-bottom: 1px solid transparent;">
											{{ getInspectionKindName(scope.row.inspectionKind) }}
										</span>
										<el-select class="sp-input small-select right-arrow"
											v-model="scope.row.inspectionKind" placeholder="请选择"
											v-if="getDisabled(scope.row.inspectionId)" style="width: 75px" clearable>
											<el-option v-for="item in inspectionKindList" :key="item.value"
												:label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</template>
								</el-table-column>
								<el-table-column prop="inspectionContent" label="巡视内容" min-width="350"
									header-align="center" fixed="left" show-overflow-tooltip>
									<template slot-scope="scope">
										<div style="line-height: 15px; white-space: pre-line;"
											v-if="!getDisabled(scope.row.inspectionId)">
											{{ scope.row.inspectionContent || '/' }}
										</div>
										<el-input type="textarea" class="sp-input"
											:autosize="{ minRows: 1, maxRows: 10 }"
											v-if="getDisabled(scope.row.inspectionId)"
											v-model="scope.row.inspectionContent"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="sutContent" label="问题描述及整改意见" header-align="center"
									min-width="350">
									<template slot-scope="scope">
										<div style="line-height: 15px; white-space: pre-line;cursor: pointer;"
											v-if="!getDisabled(scope.row.inspectionId)"
											@click="lookHandle(scope.row.inspectionId)">
											{{ scope.row.sutContent || '/' }}
										</div>
										<el-input type="textarea" class="sp-input"
											v-if="getDisabled(scope.row.inspectionId)" v-model="scope.row.sutContent"
											:autosize="{ minRows: 1, maxRows: 10 }"></el-input>
									</template>
								</el-table-column>
								<el-table-column label="提出时间" prop="inspectionTime" width="114" align="center">
									<template slot-scope="scope">
										<span v-if="!getDisabled(scope.row.inspectionId)">
											{{ scope.row.inspectionTime | formatDate('yyyy-MM-dd') }}</span>
										<el-date-picker class="sp-input small-date-picker"
											v-model="scope.row.inspectionTime" type="date" value-format="yyyy-MM-dd"
											placeholder="选择日期" style="width: 115px;"
											v-if="getDisabled(scope.row.inspectionId)">
										</el-date-picker>
									</template>
								</el-table-column>
								<el-table-column label="提出人" prop="inspectionMan" width="64" align="center">
									<template slot-scope="scope">
										<span v-if="!getDisabled(scope.row.inspectionId)">{{
											scope.row.inspectionMan
										}}</span>
										<el-input class="sp-input small-input"
											v-if="getDisabled(scope.row.inspectionId)"
											v-model="scope.row.inspectionMan"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="tracking" label="跟踪情况处理" align="center" width="240">
									<template slot-scope="scope">
										{{ scope.row.tracking }}
									</template>
								</el-table-column>
								<el-table-column prop="closeOpinion" label="封闭意见说明（如有时）" width="200" align="left">
									<template slot-scope="scope">
										<span v-if="!getDisabled(scope.row.inspectionId)">{{
											scope.row.closeOpinion
										}}</span>
										<span v-if="!getDisabled(scope.row.inspectionId)
											&& (scope.row.sutContent == '' || scope.row.sutContent == null) && scope.row.closeOpinion == ''">
											/</span>
										<el-input class="sp-input small-input" v-if="false"
											v-model="scope.row.closeOpinion"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="closeTime" label="封闭时间" width="114" align="center">
									<template slot-scope="scope">
										<span v-if="!getDisabled(scope.row.inspectionId)
											&& scope.row.closeTime != ''">
											{{ scope.row.closeTime | formatDate('yyyy-MM-dd') }}</span>
										<span v-if="!getDisabled(scope.row.inspectionId)
											&& (scope.row.sutContent == '' || scope.row.sutContent == null) && scope.row.closeTime == null">
											/</span>
										<el-date-picker class="sp-input small-date-picker" v-model="scope.row.closeTime"
											type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
											style="width: 115px;" v-if="false">
										</el-date-picker>
									</template>
								</el-table-column>
								<el-table-column prop="closeMan" label="封闭人" width="64" align="center">
									<template slot-scope="scope">
										<span v-if="!getDisabled(scope.row.inspectionId)">{{
											scope.row.closeMan
										}}</span>
										<span v-if="!getDisabled(scope.row.inspectionId)
											&& (scope.row.sutContent == '' || scope.row.sutContent == null) && scope.row.closeMan == ''">
											/</span>
										<el-input class="sp-input small-input" v-if="false"
											v-model="scope.row.closeMan"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="remark" label="备注" min-width="150" align="left"
									show-overflow-tooltip>
									<template slot-scope="scope">
										<span class="remark-content" v-if="!getDisabled(scope.row.inspectionId)">{{
											scope.row.remark
										}}</span>
										<el-input class="sp-input small-input"
											v-if="getDisabled(scope.row.inspectionId)"
											v-model="scope.row.remark"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="remark" label="等级" align="center" width="100"
									show-overflow-tooltip>
									<template slot-scope="scope">
										<el-switch v-model="scope.row.primaryFlg" active-value="1" inactive-value="0"
											active-text="突出" @change="updatePrimaryFlg(scope.row.inspectionId)">
										</el-switch>
									</template>
								</el-table-column>
								<el-table-column label="操作" width="220" align="center" fixed="right"
									header-align="center">
									<template slot-scope="scope">
										<el-button v-preventReClick type="text" size="mini"
											@click="updateHandle(scope.row.inspectionId, scope.$index)"
											v-if="showEdit && !updateFlg && !addFlg && scope.row.closeState != '1'">修改</el-button>
										<el-button v-preventReClick type="text" size="mini"
											@click="trackingHandle(scope.row.inspectionId)"
											v-if="showEdit && !updateFlg && !addFlg && scope.row.closeState != '1'">跟踪意见</el-button>
										<el-button v-preventReClick type="text" size="mini"
											@click="picAndFileHandle(scope.row.inspectionId)"
											v-if="!updateFlg && !addFlg">照片</el-button>
										<el-button v-preventReClick type="text" size="mini"
											v-if="!updateFlg && !addFlg && scope.row.closeState == '0'"
											@click="closeHandle(scope.row.inspectionId)">确认封闭</el-button>
										<el-button v-preventReClick type="text" size="mini"
											v-if="!updateFlg && !addFlg && scope.row.closeState == '1' && !updateFlg && !addFlg"
											@click="cancelCloseHandle(scope.row.inspectionId)">解除封闭</el-button>
										<!--新增时按钮-->
										<el-button v-preventReClick type="text" size="small" @click="saveInspection()"
											v-if="scope.row.inspectionId == undefined && addFlg">保存</el-button>
										<el-button v-preventReClick type="text" size="small" @click="cancelSaveHandle()"
											v-if="scope.row.inspectionId == undefined && addFlg">取消</el-button>
										<!--修改时按钮-->
										<el-button v-preventReClick type="text" size="small"
											@click="updateInspection(scope.row)"
											v-if="getDisabled(scope.row.inspectionId) && !addFlg">保存</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="cancelUpdateHandle()"
											v-if="getDisabled(scope.row.inspectionId) && !addFlg">取消</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
							@current-change="currentChangeHandle" :current-page="pageIndex"
							:page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
							layout="total, sizes, prev, pager, next, jumper" :disabled="updateFlg || addFlg">
						</el-pagination>
					</el-col>
				</el-row>
			</el-card>
		</div>
		<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList()"></add-or-update>
		<patrol-list-info v-if="lookVisible" ref="patrolInfo" @refreshDataList="getDataList()"></patrol-list-info>
		<close-problem v-if="closeProblemVisible" ref="closeProblem" @refreshDataList="getDataList()"></close-problem>
		<cancel-problem v-if="cancelProblemVisible" ref="cancelProblem"
			@refreshDataList="getDataList()"></cancel-problem>
		<excel-upload v-if="excelUploadVisible" ref="excelUpload" @refreshDataList="getDataList"></excel-upload>
		<pic-and-file v-if="picAndFileVisible" ref="picAndFile" @refreshDataList="getDataList"></pic-and-file>
		<patrol-close v-if="closeVisible" ref="patrolClose" @refreshDataList="getDataList"></patrol-close>
		<tracking v-if="showTracking" ref="tracking" @refreshDataList="getDataList"></tracking>
	</div>
</template>
<script>
import AddOrUpdate from './patrolList-add-or-update'
import CloseProblem from './../problemOpi/problem-close'
import CancelProblem from './../problemOpi/problem-cancel'
import $common from "@/utils/common.js"
import PatrolListInfo from "./patrolList-Info";
import ExcelUpload from './patrolList-excel-upload'
import PicAndFile from './patrolList-pic-and-file'
import PatrolClose from './patrol-close'
import Tracking from './tracking'
export default {
	data() {
		return {
			tabIndex: "0",
			showAdd: false,
			showSearch: false,
			showLook: false,
			showEdit: false,
			showDelete: false,
			lookVisible: false,
			primaryFlg: '',
			showTracking: false,
			addOrUpdateVisible: false,
			excelUploadVisible: false,
			disabledBatchDelete: true,
			picAndFileVisible: false,
			closeVisible: false,
			updateFlg: false,
			addFlg: false,
			showSubject: false,
			closeStateList: [
				{
					label: '全部',
					value: ''
				},
				{
					label: '已封闭',
					value: '1'
				},
				{
					label: '未封闭',
					value: '0'
				},
			],
			inspectionKindList: [
				{
					label: '日常',
					value: '1'
				},
				{
					label: '材料试验',
					value: '2'
				},
				{
					label: '热处理',
					value: '3'
				},
				{
					label: '无损探伤',
					value: '4'
				},
				{
					label: '消除应力',
					value: '5'
				},
			],
			primaryLabelList: [
				{
					label: '全部',
					value: ''
				},
				{
					label: '突出',
					value: '1'
				},
				{
					label: '正常',
					value: '0'
				},
			],
			sutContent: '',
			closeProblemVisible: false,
			cancelProblemVisible: false,
			form: {},
			categoryList: [],
			category: 0,
			subjectList: [],
			majorList: [],
			dataList: [],
			tableSelVal: [],
			tableSelIdArray: [],
			selAllFlg: false,
			subjectNo: "",
			major: "",
			closeState: '',
			sutContent: '',
			inspectionContent: '',
			poseTime: [],
			closeTime: [],
			//当前页码
			pageIndex: 1,
			// 显示序号
			pageIndex2: 1,
			//当前记录数
			pageSize: 20,
			//总页数
			totalPage: 0,
			pageSpan: 12,
			recNos: [],
			importantList: [],
			dataTotal: {
				closeNum: 0,
				nonCloseNum: 0
			},
			title: '',
			screenHeight: 0
		};
	},
	components: {
		PatrolListInfo,
		AddOrUpdate, CloseProblem,
		CancelProblem,
		ExcelUpload,
		PicAndFile,
		PatrolClose,
		Tracking
	},
	filters: {
		formatDate: function (value, args) {
			if (!value) {
				return ''
			}
			var dt = new Date(value);
			if (args == 'yyyy-M-d') {// yyyy-M-d
				let year = dt.getFullYear();
				let month = dt.getMonth() + 1;
				let date = dt.getDate();
				return `${year}-${month}-${date}`;
			} else if (args == 'yyyy-M-d H:m:s') {// yyyy-M-d H:m:s
				let year = dt.getFullYear();
				let month = dt.getMonth() + 1;
				let date = dt.getDate();
				let hour = dt.getHours();
				let minute = dt.getMinutes();
				let second = dt.getSeconds();
				return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
			} else if (args == 'yyyy-MM-dd') {// yyyy-MM-dd
				let year = dt.getFullYear();
				let month = (dt.getMonth() + 1).toString().padStart(2, '0');
				let date = dt.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${date}`;
			} else {// yyyy-MM-dd HH:mm:ss
				let year = dt.getFullYear();
				let month = (dt.getMonth() + 1).toString().padStart(2, '0');
				let date = dt.getDate().toString().padStart(2, '0');
				let hour = dt.getHours().toString().padStart(2, '0');
				let minute = dt.getMinutes().toString().padStart(2, '0');
				let second = dt.getSeconds().toString().padStart(2, '0');
				return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
			}
		}
	},
	mounted() {
		this.screenHeight = window.innerHeight
		this.category = this.$route.query.type;
		if (this.category === '1') {
			this.title = '质量巡视'
		} else if (this.category === '2') {
			this.title = '安全巡视'
		}
		this.showAdd = $common.isAuth('patrol:add:' + this.category);
		this.showSearch = $common.isAuth('patrol:search:' + this.category);
		this.showLook = $common.isAuth('patrol:look:' + this.category);
		this.showEdit = $common.isAuth('patrol:edit:' + this.category);
		this.showDelete = $common.isAuth('patrol:delete:' + this.category);
		if (!this.showAdd) {
			this.pageSpan = 24;
		} else {
			this.pageSpan = 12;
		}
		this.pageIndex = 1;
		this.pageIndex2 = 1;
		// if (this.showSearch) {
		// 	this.getDataList();
		// }

		if (this.closeStateList != undefined && this.closeStateList.length > 0) {
			this.closeState = this.closeStateList[0].value
		}

		this.getAllSubjectDropDown();
		this.getAllMajorList();
		this.getProblemImportant();
	},
	methods: {
		getTableHeight() {
			let majorHeight = 0;
			if (this.majorList.length > 5) {
				majorHeight = 25;
			}
			if (this.showSubject) {
				return this.screenHeight - 328 - majorHeight + 'px';
			}
			return this.screenHeight - 295 - majorHeight + 'px';
		},
		getCurrentTime() {
			//获取当前时间并打印
			var _this = this;
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			let hh = new Date().getHours();
			let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
			let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
			return yy + '-' + mm + '-' + dd;
		},
		addHandle() {
			if (this.subjectNo == undefined || this.subjectNo == '') {
				this.$message.error("请选择标的物！")
				return;
			}
			if (this.major == undefined || this.major == '') {
				this.$message.error("请选择专业！")
				return;
			}
			let _url = "/business/inspectioninfo/getLastInspectionInfo";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					workNo: $common.getItem("workNo"),
					category: this.category,
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					// 首行新增一条记录
					let dataList = [];
					let mooringTest = {
						workNo: $common.getItem("workNo"),
						subjectNo: this.subjectNo,
						major: this.major,
						category: this.category,
						inspectionMan: $common.getItem("userName"),
						inspectionPlace: '',
						inspectionContent: '',
						sutContent: '',
						inspectionTime: this.getCurrentTime(),
						closeTime: '',
						closeMan: '',
						closeOpinion: '',
						iptFlg: '',
						remark: '',
					}
					dataList.push(mooringTest);
					for (var i = 0; i < this.dataList.length; i++) {
						dataList.push(this.dataList[i])
					}
					this.dataList = dataList
					this.addFlg = true;
				}
			});
		},
		cancelSaveHandle() {
			this.addFlg = false;
			let dataList = [];
			for (var i = 0; i < this.dataList.length; i++) {
				if (this.dataList[i].inspectionId != undefined) {
					dataList.push(this.dataList[i])
				}
			}
			this.dataList = dataList
		},
		updateHandle(val, index) {
			this.recNos.push(val)
			this.updateFlg = true;
			// if (this.dataList[index].inspectionContent != undefined && this.dataList[index].inspectionContent == '/') {
			// 	this.dataList[index].inspectionContent = ''
			// }
			// if (this.dataList[index].sutContent != undefined && this.dataList[index].sutContent == '/') {
			// 	this.dataList[index].sutContent = ''
			// }
		},
		cancelUpdateHandle() {
			this.getDataList()
			this.recNos = [];
			this.updateFlg = false;
		},
		getDisabled(val) {
			if (val == '' || val == undefined) {
				return true;
			} else {
				if (this.recNos.includes(val) && this.updateFlg) {
					return true;
				}
				return false;
			}
		},
		getInspectionKindName(value) {
			if (!value) return '';
			// 从列表中查找匹配项
			const matchItem = this.inspectionKindList.find(item => item.value === value);
			// 找到则返回label，未找到返回原value（兜底）
			return matchItem ? matchItem.label : value;
		},
		saveInspection() {
			if (this.dataList[0].subjectNo == null || this.dataList[0].subjectNo == "") {
				this.$message.error("请选择标的物");
				return;
			}

			if (this.dataList[0].inspectionTime == null || this.dataList[0].inspectionTime == "") {
				this.$message.error("请填写提出时间");
				return;
			}

			if (this.dataList[0].inspectionMan == null || this.dataList[0].inspectionMan == "") {
				this.$message.error("请填写提出人");
				return;
			}

			let _url = "/business/inspectioninfo/save";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData(this.dataList[0])
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getDataList()
					this.addFlg = false
				}
			});
		},
		updateInspection(val) {
			if (val.subjectNo == null || val.subjectNo == "") {
				this.$message.error("请选择标的物");
				return;
			}

			if (val.inspectionTime == null || val.inspectionTime == "") {
				this.$message.error("请填写提出时间");
				return;
			}

			if (val.inspectionMan == null || val.inspectionMan == "") {
				this.$message.error("请填写提出人");
				return;
			}

			let _url = "/business/inspectioninfo/update";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData(val)
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getDataList()
					this.updateFlg = false
					this.recNos = [];
				}
			});
		},
		cancelCloseHandle(inspectionId) {
			this.$confirm(`确定要解除封闭吗？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/inspectioninfo/cancelCloseInspection/" + inspectionId,
					method: 'post',
					params: {}
				}).then(({
					data
				}) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
						})
						this.getDataList();
					}
				})
			});
		},
		getProblemImportant() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getProblemImportant",
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.importantList = data.body;
				}
			});
		},
		picAndFileHandle(id) {
			this.picAndFileVisible = true;
			this.$nextTick(() => {
				this.$refs.picAndFile.init(id)
			})
		},
		closeHandle(id) {
			this.closeVisible = true;
			this.$nextTick(() => {
				this.$refs.patrolClose.init(id)
			})
		},
		siteContentViewHeight() {
			var height = this.$store.state.common.documentClientHeight - 260;
			return { height: height + 'px' }
		},
		handleSelectionChange(selection) {
			this.tableSelVal = selection;
			if (selection.length > 0) {
				this.disabledBatchDelete = false;
			} else {
				this.disabledBatchDelete = true;
			}
		},
		checkboxInit(row) {
			return 1;
		},
		lookHandle(id) {
			this.lookVisible = true;
			this.$nextTick(() => {
				this.$refs.patrolInfo.init(id)
			})
		},
		uploadHandle() {
			this.excelUploadVisible = true;
			this.$nextTick(() => {
				this.$refs.excelUpload.init(this.category)
			})
		},
		downloadTemplate() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getTemplateUrl?type=4",
				method: 'get',
				params: {}
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					if (data.body) {
						if (this.$store.state.showTestFlag) {
							window.open(data.body)
						} else {
							this.global.downLoadFile(data.body, '巡视记录表模板.xlsx');
						}
					} else {
						this.$message.error("未配置模板，请联系运维管理人员")
					}
				}
			});
		},
		downloadHandle() {
			const rLoading = this.openLoading();
			this.$http({
				url: this.$store.state.httpUrl + "/business/inspectioninfo/download",
				method: 'get',
				params: this.$http.adornParams({
					workNo: $common.getItem("workNo"),
					subjectNo: this.subjectNo,
					category: this.category,
					major: this.major,
					closeState: this.closeState,
					sutContent: this.sutContent,
					inspectionContent: this.inspectionContent,
					beginTime: this.poseTime[0] ? this.poseTime[0] : "",
					endTime: this.poseTime[1] ? this.poseTime[1] : "",
				})
			}).then(({ data }) => {
				rLoading.close();
				if (data && data.resultCode === 200) {
					if (this.$store.state.showTestFlag) {
						if (data.body != null && data.body.length > 0) {
							for (var i = 0; i < data.body.length; i++) {
								window.open(data.body[i].fileUri)
							}
						}
					} else {
						if (data.body != null && data.body.length > 0) {
							for (var i = 0; i < data.body.length; i++) {
								this.global.downLoadFile(data.body[i].fileUri, data.body[i].subjectName + '巡视记录表.xlsx');
							}
						}
					}
				} else {
				}
			})
		},
		downloadAllDataHandle() {
			const rLoading = this.openLoading();
			this.$http({
				url: this.$store.state.httpUrl + "/business/inspectioninfo/download",
				method: 'get',
				params: this.$http.adornParams({
					workNo: $common.getItem("workNo"),
					subjectNo: this.subjectNo,
				})
			}).then(({ data }) => {
				rLoading.close();
				if (data && data.resultCode === 200) {
					if (this.$store.state.showTestFlag) {
						window.open(data.body)
					} else {
						this.global.downLoadFile(data.body, '巡视记录表.xlsx');
					}
				} else {
				}
			})
		},
		trackingHandle(id) {
			this.showTracking = true;
			this.$nextTick(() => {
				this.$refs.tracking.init(id)
			})
		},
		addOrUpdateHandle(id) {
			this.addOrUpdateVisible = true;
			this.$nextTick(() => {
				this.$refs.addOrUpdate.init(id, this.category)
			})
		},
		selGetDataList() {
			this.pageIndex = 1;
			this.getDataList();
		},
		currentChangeHandle(val) {
			this.pageIndex = val
			this.getDataList()
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val;
			this.pageIndex = 1;
			this.getDataList()
		},
		countInspection() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/inspectioninfo/countInspection",
				method: 'get',
				params: this.$http.adornParams({
					workNo: $common.getItem("workNo"),
					subjectNo: this.subjectNo,
					category: this.category,
					major: this.major,
					closeState: this.closeState,
					sutContent: this.sutContent,
					inspectionContent: this.inspectionContent,
					beginTime: this.poseTime[0] ? this.poseTime[0] : "",
					endTime: this.poseTime[1] ? this.poseTime[1] : "",
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataTotal = data.body
				}
			})
		},
		getDataList() {
			this.countInspection()
			this.$http({
				url: this.$store.state.httpUrl + "/business/inspectioninfo/list",
				method: "get",
				params: {
					workNo: $common.getItem("workNo"),
					subjectNo: this.subjectNo,
					category: this.category,
					major: this.major,
					closeState: this.closeState,
					sutContent: this.sutContent,
					primaryFlg: this.primaryFlg,
					inspectionContent: this.inspectionContent,
					beginTime: this.poseTime[0] ? this.poseTime[0] : "",
					endTime: this.poseTime[1] ? this.poseTime[1] : "",
					limit: this.pageSize,
					page: this.pageIndex
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataList = data.body.records;
					this.totalPage = data.body.totalCount;
					this.pageIndex2 = this.pageIndex
				}
			});
		},
		getAllSubjectDropDown() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getAllSubjectDropDown/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.subjectList = data.body;
					if (this.subjectList != undefined && this.subjectList.length > 0) {
						this.subjectNo = this.subjectList[0].displayValue
						if (this.showSearch) {
							this.getDataList();
						}
					}
					if (this.subjectList != undefined && this.subjectList.length > 1) {
						this.showSubject = true
					} else {
						this.showSubject = false
					}
				}
			});
		},
		getAllMajorList() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getAllMajorByWorkNo/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.majorList = data.body;
					if (this.majorList != undefined && this.majorList.length > 0) {
						this.major = this.majorList[0].displayValue
						if (this.showSearch) {
							this.getDataList();
						}
					}
				}
			});
		},
		setClo(closeState) {
			if (!this.addFlg && !this.updateFlg) {
				this.closeState = closeState.value
				this.getDataList()
			}
		},
		setPrimary(primaryFlg) {
			if (!this.addFlg && !this.updateFlg) {
				this.primaryFlg = primaryFlg.value
				this.getDataList()
			}
		},
		updatePrimaryFlg(id) {
			if (!id) {
				return;
			}
			this.$http({
				url: this.$store.state.httpUrl + "/business/inspectioninfo/updateInspectionPrimaryFlg/" + id,
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.getDataList()
				}
			});
		},
		setMajor(major) {
			if (!this.addFlg && !this.updateFlg) {
				this.major = major.displayValue
				this.getDataList()
			}
		},
		setSubject(subject) {
			if (!this.addFlg && !this.updateFlg) {
				this.subjectNo = subject.displayValue
				this.getDataList()
			}
		},
		toggleAllSelection() {
			this.$refs.dataListTable.toggleAllSelection();
		},
		resetFormData() {
			this.sutContent = ''
			this.inspectionContent = ''
			this.poseTime = [];
			this.getDataList()
		},
		closeProblemHandle(id) {
			this.closeProblemVisible = true
			this.$nextTick(() => {
				this.$refs.closeProblem.init(id)
			})
		},
		cancelProblemHandle(id) {
			this.cancelProblemVisible = true
			this.$nextTick(() => {
				this.$refs.cancelProblem.init(id)
			})
		},
		deleteHandle(id) {
			this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/inspectioninfo/delete/" + id,
					method: "POST"
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					} else {
						this.$message.error(data.msg)
					}
				});
			})
		},
		deleteBatch() {
			this.$confirm(`确定对选中的数据进行删除操作？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let records = this.tableSelVal.map((item) => item.inspectionId);
				this.$http({
					url: this.$store.state.httpUrl + "/business/inspectioninfo/deleteBatch",
					method: 'post',
					data: this.$http.adornData({
						records: records
					})
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					}
				});
			});
		},
		tableRowClassName({ row, rowIndex }) {
			// return $common.tableRowClassName({ row, rowIndex });
			// 当 useFlg == '1' 时应用背景色
			if (row.closeState === '0') {
				// return 'discolour-row';
				// return 'use-flg-row';
				return 'close-row';
			}
			return '';
		},
		selectRowBackground({ row }) {
			const checkIdList = this.tableSelVal.map((item) => item.inspectionId);
			if (checkIdList.includes(row.inspectionId)) {
				return {
					backgroundColor: "#fae8cb",
				};
			}
		},
	}
};
</script>
<style scoped>
.selItemText {
	font-size: 14px;
	color: #1c1c1c;
	display: inline-block;
	width: 80px;
}

.noteTitle {
	font-weight: bold;
	color: #00428e;
	border-bottom: 1px solid #00428e;
	padding-bottom: 10px;
}

.noteContent {
	color: #727580;
	margin-top: 10px;
	line-height: 25px;
}

.my-pagination {
	margin-right: 20px !important;
	margin-top: -10px !important;
}

/* 表格样式补充 */
::v-deep(.el-table th.el-table__cell) {
	padding: 0 0px !important;
	/* 表头左右内边距改为2px，上下保持0 */
	height: 15px !important;
	line-height: 15px !important;
}

::v-deep(.el-table .el-table__row .el-table__cell) {
	font-size: 12px !important;
	height: auto !important;
	padding: 0 0px !important;
	/* 单元格左右内边距强制设为2px（核心修改） */
	line-height: 15px !important;
	white-space: normal !important;
	word-break: break-all !important;
}

/* 去除表格边框间距 */
::v-deep(.el-table) {
	border-collapse: collapse !important;
}

::v-deep(.el-table__header-wrapper) {
	border-bottom: 0px solid #EBEEF5 !important;
}

::v-deep(.el-table__body-wrapper) {
	border-top: none !important;
	z-index: 2
}

.sp-input /deep/ .el-textarea__inner {
	font-size: 12px;
	min-height: 30px !important;
	/* 最小高度 */
	line-height: 15px !important;
	padding: 5px 8px !important;
}

/* 使用更具体的选择器路径并添加 !important */
::v-deep .el-select-dropdown.el-popper .el-scrollbar .el-select-dropdown__list .el-select-dropdown__item {
	font-size: 12px !important;
	height: 30px !important;
	line-height: 30px !important;
	padding: 0 10px !important;
}

/* 也可以单独为hover状态设置 */
::v-deep .el-select-dropdown.el-popper .el-scrollbar .el-select-dropdown__list .el-select-dropdown__item:hover {
	font-size: 12px !important;
}

/* 确保所有下拉框都应用 */
::v-deep .el-select-dropdown {
	font-size: 12px !important;
}

/* 表格内的选择器需要更具体 */
.dataListTable .sp-input ::v-deep .el-select-dropdown__item {
	font-size: 12px !important;
}

/* 或者使用属性选择器增加特异性 */
.el-select-dropdown__item[data-v-76e66394] {
	font-size: 12px !important;
}

/* 若需要同时调整输入框内的字体 */
::v-deep .el-select .el-input__inner {
	font-size: 12px !important;
}

.sp-input /deep/ .el-select .el-input__inner {
	font-size: 12px;
}

.sp-input /deep/ .el-select-dropdown__item {
	font-size: 12px;
}

.sp-input /deep/ .el-textarea__inner {
	font-size: 12px;
}

.selSubjectInput /deep/ .el-input__inner {
	width: 120px !important;
	height: 30px !important;
}

.selDateInput {
	width: 270px !important;
	margin-top: 5px;
	height: 30px;
}

.selSearchInput /deep/ .el-input__inner {
	width: 180px !important;
	height: 30px !important;
	font-size: 12px;
}

.selMajorInput /deep/ .el-input__inner {
	width: 110px !important;
	height: 30px !important;
}

.selDateInput /deep/ .el-range-separator {
	width: 40px !important;
	margin-top: -8px;
}

.selDateInput /deep/ .el-range__icon {
	line-height: 25px !important;
}

.selDateInput /deep/ .el-range__close-icon {
	line-height: 25px !important;
}

.selFormItem::v-deep .el-form-item__label {
	font-size: smaller;
}

.selFormItem2::v-deep .el-form-item__label {
	font-size: smaller;
	width: 120px !important;
	margin-left: -10px;
	margin-top: -1px
}

.box {
	height: 100%;
	overflow: auto;
}

.sp-input.small-select ::v-deep .el-input__inner {
	height: 30px !important;
	line-height: 30px !important;
	font-size: 12px !important;
	padding-right: 5px !important;
	width: 75px !important;
}

.sp-input.small-select ::v-deep .el-input__suffix {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
}

.sp-input.small-select ::v-deep .el-input__icon {
	line-height: 30px !important;
	height: 30px !important;
}

.sp-input.small-date-picker ::v-deep .el-input__inner {
	height: 30px !important;
	line-height: 30px !important;
	font-size: 12px !important;
	padding: 0 10px 0 30px !important;
}

.sp-input.small-date-picker ::v-deep .el-input__prefix {
	left: 8px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
}

.sp-input.small-date-picker ::v-deep .el-input__icon {
	line-height: 30px !important;
	height: 30px !important;
}

.sp-input.small-input ::v-deep .el-input__inner {
	height: 30px !important;
	line-height: 30px !important;
	font-size: 12px !important;
	min-height: 30px !important;
	margin-left: -10px;
}

::v-deep(.el-table .el-table__cell) {
	height: auto !important;
	min-height: 30px !important;
}

::v-deep(.el-table__body .el-input__inner) {
	width: 220px !important;
}

::v-deep(.el-table__row) {
	height: auto !important;
	min-height: 30px !important;
}

/* 移除所有边框，只保留底部边框 */
.sp-input.small-select ::v-deep .el-input__inner,
.sp-input.small-date-picker ::v-deep .el-input__inner,
.sp-input.small-input ::v-deep .el-input__inner,
.sp-input ::v-deep .el-textarea__inner {
	border: none !important;
	/* border-bottom: 1px solid #DCDFE6 !important; */
	border-radius: 0 !important;
	background-color: transparent !important;
	padding-left: 0 !important;
	/* padding-right: 0 !important; */
	box-shadow: none !important;
}

/* hover状态 */
.sp-input.small-select:hover ::v-deep .el-input__inner,
.sp-input.small-date-picker:hover ::v-deep .el-input__inner,
.sp-input.small-input:hover ::v-deep .el-input__inner,
.sp-input:hover ::v-deep .el-textarea__inner {
	/* border-bottom: 1px solid #409EFF !important; */
}

/* focus状态 */
/* .sp-input.small-select.is-focus ::v-deep .el-input__inner,
.sp-input.small-date-picker.is-focus ::v-deep .el-input__inner,
.sp-input.small-input.is-focus ::v-deep .el-input__inner,
.sp-input.is-focus ::v-deep .el-textarea__inner {
	border-bottom: 1px solid #409EFF !important;
} */

.sp-input.small-date-picker ::v-deep .el-input__inner {
	padding-left: 25px !important;
	/* 调整日期图标位置 */
	padding-right: 0 !important;
}

/* 调整el-date-picker前缀图标位置 */
.sp-input.small-date-picker ::v-deep .el-input__prefix {
	left: 0 !important;
	width: 20px !important;
}

/* 调整textarea底部边框 */
.sp-input ::v-deep .el-textarea__inner {
	min-height: 30px !important;
	line-height: 15px !important;
	padding: 5px 0 !important;
	resize: none !important;
	/* 禁止拖拽 */
}

/* 确保表格单元格内边距 */
::v-deep(.el-table .el-table__cell) {
	padding: 0 8px !important;
}

/* 巡检类型下拉框 - 箭头在右侧，保持与文本对齐 */
.sp-input.small-select.right-arrow ::v-deep .el-input__inner {
	padding-right: 5px !important;
	text-align: left !important;
}

/* 确保下拉箭头在右侧 */
.sp-input.small-select.right-arrow ::v-deep .el-input__suffix {
	right: 0 !important;
}

.sp-input ::v-deep .el-input__inner,
.sp-input ::v-deep .el-textarea__inner {
	font-size: 12px;
	min-height: 30px !important;
	line-height: 15px !important;
	padding: 5px 0px !important;
	/* 输入框内边距左右改为2px，匹配单元格间距 */
	margin: 0 !important;
	/* 去除输入框额外外边距 */
	width: 100% !important;
	/* 输入框宽度铺满单元格 */
	box-sizing: border-box !important;
	/* 确保内边距不超出宽度 */
}

/* 下拉选择框适配 */
.sp-input ::v-deep .el-select .el-input__inner {
	padding-left: 0px !important;
	padding-right: 0px !important;
}

/* 日期选择器适配 */
.sp-input ::v-deep .el-date-editor .el-input__inner {
	padding: 0 0px !important;
	width: 100% !important;
}

/* 下拉选项样式适配 */
::v-deep .el-select-dropdown.el-popper .el-scrollbar .el-select-dropdown__list .el-select-dropdown__item {
	font-size: 12px !important;
	height: 30px !important;
	line-height: 30px !important;
	padding: 0 0px !important;
	/* 下拉选项左右内边距2px */
}

::v-deep .el-select-dropdown.el-popper .el-scrollbar .el-select-dropdown__list .el-select-dropdown__item:hover {
	font-size: 12px !important;
}

/* 小尺寸输入框特殊适配 */
.sp-input.small-input ::v-deep .el-input__inner {
	padding: 0 0px !important;
}

.sp-input.small-date-picker ::v-deep .el-date-editor .el-input__inner {
	width: 100% !important;
	padding: 0 0px !important;
}

.sp-input.small-select ::v-deep .el-select .el-input__inner {
	width: 100% !important;
	padding: 0 0px !important;
}

/* 确保备注列内容不会溢出到操作列下方 */
.remark-content {
	display: block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 100%;
}

/* 固定列的单元格背景设为白色，确保完全覆盖下方内容 */
::v-deep(.el-table__fixed) {
	z-index: 2 !important;  /* 从 3 改为 2，低于滚动条区域或持平 */
	pointer-events: none;   /* 让固定列容器不拦截鼠标事件，但内部单元格仍需可点 */
}

/* 确保固定列的单元格边框完整 */
::v-deep(.el-table__fixed-right::before) {
	background-color: white !important;
	box-shadow: -1px 0 0 #EBEEF5 !important;
	/* 模拟边框，防止穿透 */
}

/* 确保表格横向滚动条出现时，固定列完全覆盖 */
::v-deep(.el-table__body-wrapper) {
	overflow-x: auto !important;
	/* 确保滚动条区域可交互 */
	position: relative;
	z-index: 1;
}

/* 确保固定列单元格的padding和内边距正常 */
::v-deep(.el-table__fixed .el-table__cell) {
	padding: 0 8px !important;
	box-shadow: none !important;
	pointer-events: auto;   /* 恢复单元格的鼠标事件 */
}

/* 固定列表头也需要恢复鼠标事件 */
::v-deep(.el-table__fixed-header-wrapper) {
	pointer-events: auto;
}

/* 固定列表体也需要恢复鼠标事件 */
::v-deep(.el-table__fixed-body-wrapper) {
	pointer-events: auto;
}
</style>
